import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DashboardService } from '../dashboard.service';
@Component({
  selector: 'app-energy-meter',
  templateUrl: './energy-meter.component.html',
  styleUrls: ['./energy-meter.component.scss']
})
export class EnergyMeterComponent implements OnInit {

  private ResponseVerifiedMpptData: Subject<any> = new Subject();
  private ResponseVerifiedInverterList: Subject<any> = new Subject();
  private ResponseVerifiedwmsMeterList: Subject<any> = new Subject();
  private ResponseWmsMpptData: Subject<any> = new Subject();
  private ResponseVerifiedNormalUserParmeterAndValue: Subject<any> = new Subject();
  role: any;
  roleName: string;
  mpptDataDetailsArray: any = [];
  wmsMpptDataDetailsArray: any = [];
  mpptStringDataArray: any;
  page = 1;
  public inverterform: FormGroup;
  public wmsinverterform: FormGroup;
  inverterDetails_id: any;
  public inverterList: any = [];
 public  wmsMeterList: any = [];
  public serial_no: any;
  public meter_id: any;
  public subDevice_id: any;
  public wmsSubDevice_id: any;
  inverterObj: any;
  public parameterAndValue: any = [];
  public parameterListRequestObject: { serial_no: any; sub_device_id: any; };
  constructor(private router: Router, private dashboardService: DashboardService,
              private toastr: ToastrService, private fb: FormBuilder) {
    this.role = localStorage.role;
    if (this.role === '1') {
      this.roleName = 'admin';
    } else if (this.role === '2') {
      this.roleName = 'epc';
    } else if (this.role === '3') {
      this.roleName = 'wms';
    } else if (this.role === '4') {
      this.roleName = 'normal';
    }
    else if (this.role === '6') {
      this.roleName = 'ze';
    }
    else if (this.role === '7') {
      this.roleName = 'dg';
    }
  }

  ngOnInit() {
    this.inverterform = this.fb.group({
      inverter_id: [null, Validators.required],
    });
    this.wmsinverterform = this.fb.group({
      wmsinverter_id: [null, Validators.required],
    });
     if (this.roleName === 'wms') {
     // this.getWmsMeterList();
      this.getWmsInverterList();
   }
   if (this.roleName === 'ze'||this.roleName === 'dg' ) {
    // this.getWmsMeterList();
     this.getZEInverterList();
  }
  }


// onchange normal user inverter
  onChange(value) {
    this.wmsSubDevice_id = value;
    for (let i = 0; i < this.wmsMeterList.length; i++) {
      if (this.wmsMeterList[i].id == value) {
        this.wmsSubDevice_id = this.wmsMeterList[i].sub_device_id;
        this.serial_no = this.wmsMeterList[i].serial_no;
      }
    }
    this.getParameterAndValueList();
  }
  onChangeZE(value) {
    this.wmsSubDevice_id = value;
    for (let i = 0; i < this.wmsMeterList.length; i++) {
      if (this.wmsMeterList[i].id == value) {
        this.wmsSubDevice_id = this.wmsMeterList[i].sub_device_id;
        this.serial_no = this.wmsMeterList[i].serial_no;
      }
    }
    this.getParameterAndValueListZE();
  }
  onChangeWmsInv(value) {

    this.wmsSubDevice_id = value;
    this.getParameterAndValueList();
  }
  // get normal user inverter list on drop Down
  // public getWmsMeterList() {

  //   this.dashboardService.getWmsUsersMeterList()
  //     .pipe(takeUntil(this.ResponseVerifiedInverterList))
  //     .subscribe(
  //       async result => {
  //         if (result.status) {
  //           this.inverterList = result.resultObject;
  //           this.serial_no = this.inverterList[0].serial_no;
  //           this.subDevice_id = this.inverterList[0].sub_device_id;
  //           // this.inverterDetails_id = this.inverterList[0].id;
  //           this.meter_id =  this.inverterList[0].id;
  //           this.inverterform.get('wmsinverter_id').setValue(this.meter_id);
  //           this.getParameterAndValueList();

  //         } else if (!result.status) {

  //           if (result.message === 'Unauthorised or Login Time-out') {
  //             this.toastr.info(result.message);
  //             this.router.navigate(['/login']);

  //           } else {
  //             this.toastr.info(result.message);

  //           }

  //         }
  //       },
  //       err => {
  //         return console.error(err);
  //       }
  //     );
  // }

   // get wms user inverter list on drop Down
   public getWmsInverterList() {

    this.dashboardService.getWmsMeterList()
      .pipe(takeUntil(this.ResponseVerifiedwmsMeterList))
      .subscribe(
        async result => {
          this.wmsMeterList = [];
          if (result.status) {
            this.wmsMeterList = result.resultObject;
           // this.wmsSubDevice_id = this.wmsMeterList[0].id;
            this.serial_no = this.wmsMeterList[0].serial_no;
            this.wmsSubDevice_id = this.wmsMeterList[0].sub_device_id;
            this.meter_id =  this.wmsMeterList[0].id;

            this.wmsinverterform.get('wmsinverter_id').setValue(this.meter_id);
            this.getParameterAndValueList();
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }


    // get ze user inverter list on drop Down
    public getZEInverterList() {

      this.dashboardService.getZEMeterList()
        .pipe(takeUntil(this.ResponseVerifiedwmsMeterList))
        .subscribe(
          async result => {
            this.wmsMeterList = [];
            if (result.status) {
              this.wmsMeterList = result.resultObject;
             // this.wmsSubDevice_id = this.wmsMeterList[0].id;
              this.serial_no = this.wmsMeterList[0].serial_no;
              this.wmsSubDevice_id = this.wmsMeterList[0].sub_device_id;
              this.meter_id =  this.wmsMeterList[0].id;

              this.wmsinverterform.get('wmsinverter_id').setValue(this.meter_id);
              this.getParameterAndValueListZE();
            } else if (!result.status) {
              if (result.message === 'Unauthorised or Login Time-out') {
                this.toastr.info(result.message);
                this.router.navigate(['/login']);

              } else {
                this.toastr.info(result.message);

              }

            }
          },
          err => {
            return console.error(err);
          }
        );
    }

// ze User Dashboard Parameters and value list
public getParameterAndValueListZE() {

  this.parameterListRequestObject = {
    serial_no: this.serial_no,
    sub_device_id: this.wmsSubDevice_id
  }
  this.dashboardService.getParameterAndValueListZE(this.parameterListRequestObject)
    .pipe(takeUntil(this.ResponseVerifiedNormalUserParmeterAndValue))
    .subscribe(
      async result => {
        this.parameterAndValue = []
        if (result.status) {
          this.parameterAndValue = result.resultObject;
          //   this.loaderService.display(true);

        } else if (!result.status) {
          if (result.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(result.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(result.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
}

   // Normal User Dashboard Parameters and value list
   public getParameterAndValueList() {

    this.parameterListRequestObject = {
      serial_no: this.serial_no,
      sub_device_id: this.wmsSubDevice_id
    }
    this.dashboardService.getWmsParameterAndValueList(this.parameterListRequestObject)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserParmeterAndValue))
      .subscribe(
        async result => {
          this.parameterAndValue = []
          if (result.status) {
            this.parameterAndValue = result.resultObject;
            //   this.loaderService.display(true);

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }




  ngOnDestroy() {
    this.ResponseVerifiedMpptData.next();
    this.ResponseVerifiedMpptData.complete();

    this.ResponseVerifiedInverterList.next();
    this.ResponseVerifiedInverterList.complete();

    this.ResponseVerifiedwmsMeterList.next();
    this.ResponseVerifiedwmsMeterList.complete();

    this.ResponseWmsMpptData.next();
    this.ResponseWmsMpptData.complete();
  }
}
